import type { VendorPORow } from '../api/types'

function todayIso(): string {
  return new Date().toISOString().slice(0, 10)
}

export function isOverduePO(row: Pick<VendorPORow, 'expected_receipt'>): boolean {
  if (!row.expected_receipt) return false
  return row.expected_receipt < todayIso()
}

export function daysPastDue(isoDate: string | null): number | null {
  if (!isoDate) return null
  const today = new Date(todayIso())
  const due = new Date(isoDate)
  const ms = today.getTime() - due.getTime()
  if (Number.isNaN(ms)) return null
  return Math.floor(ms / (24 * 3600 * 1000))
}
